import React, { useEffect, useState } from 'react'
import { Card, Form, Input, Button, message, Spin } from 'antd'
import { useLocation, useHistory } from 'react-router-dom'
import { LockOutlined } from '@ant-design/icons'
import { setPassword } from '../../utils'
import { passwordRules } from '../../utils/consts'

const SetPassword: React.FC = () => {
    const [loading, setLoading] = useState(false)
    const [token, setToken] = useState<string | null>(null)
    const history = useHistory()
    const location = useLocation()
    const [form] = Form.useForm()

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const inviteToken = params.get('token')

        if (!inviteToken) {
            message.error('Invalid or missing token')
            history.push('/login')
            return
        }
        setToken(inviteToken)
    }, [location, history])

    const handleSubmit = async (values: { password: string }) => {
        if (!token) {
            message.error('Invalid or expired invitation link')
            return
        }

        setLoading(true)
        try {
            await setPassword({ token, password: values.password })
            message.success('Password set successfully. Please login.')
            history.push('/login')
        } catch (err) {
            message.error('Failed to set password. Link may be expired.')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Spin spinning={loading}>
                <Card title="Set Your Password" style={{ width: 380 }}>
                    <Form form={form} layout="vertical" onFinish={handleSubmit}>
                        <Form.Item
                            name="password"
                            label="New Password"
                            rules={passwordRules}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="Enter new password"
                            />
                        </Form.Item>

                        <Form.Item
                            name="confirmPassword"
                            label="Confirm Password"
                            dependencies={['password']}
                            rules={[
                                {
                                    required: true,
                                    message: 'Please confirm password',
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (
                                            !value ||
                                            getFieldValue('password') === value
                                        ) {
                                            return Promise.resolve()
                                        }
                                        return Promise.reject(
                                            new Error('Passwords do not match')
                                        )
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                prefix={<LockOutlined />}
                                placeholder="Confirm password"
                            />
                        </Form.Item>

                        <Button type="primary" htmlType="submit" block>
                            Set Password
                        </Button>
                    </Form>
                </Card>
            </Spin>
        </div>
    )
}

export default SetPassword
